import { render } from "./CoverUploaderComponent.vue?vue&type=template&id=19f424a6&scoped=true&ts=true"
import script from "./CoverUploaderComponent.vue?vue&type=script&lang=ts"
export * from "./CoverUploaderComponent.vue?vue&type=script&lang=ts"

import "./CoverUploaderComponent.vue?vue&type=style&index=0&id=19f424a6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19f424a6"]])

export default __exports__